export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-tablet-landscape-9d8e5f6b1015ed91a2315008bada06b8.svg";